import type { payment } from '~/infra/api/rpc';

export enum PaymentPlatform {
  PAYMENT_PLATFORM_UNSPECIFIED = 'PAYMENT_PLATFORM_UNSPECIFIED',
  PAYMENT_PLATFORM_TELLER = 'PAYMENT_PLATFORM_TELLER',
  PAYMENT_PLATFORM_IOS = 'PAYMENT_PLATFORM_IOS',
  PAYMENT_PLATFORM_ANDROID = 'PAYMENT_PLATFORM_ANDROID',
  PAYMENT_PLATFORM_CREDIT_CARD = 'PAYMENT_PLATFORM_CREDIT_CARD',
  PAYMENT_PLATFORM_DOCOMO = 'PAYMENT_PLATFORM_DOCOMO',
  PAYMENT_PLATFORM_AU = 'PAYMENT_PLATFORM_AU',
  PAYMENT_PLATFORM_SOFTBANK = 'PAYMENT_PLATFORM_SOFTBANK',
  PAYMENT_PLATFORM_STRIPE = 'PAYMENT_PLATFORM_STRIPE',
}

export enum StripePaymentClientAction {
  STRIPE_PAYMENT_CLIENT_ACTION_UNSPECIFIED = 'STRIPE_PAYMENT_CLIENT_ACTION_UNSPECIFIED',
  STRIPE_PAYMENT_CLIENT_ACTION_ALREADY_SUBSCRIBED = 'STRIPE_PAYMENT_CLIENT_ACTION_ALREADY_SUBSCRIBED',
  STRIPE_PAYMENT_CLIENT_ACTION_NONE = 'STRIPE_PAYMENT_CLIENT_ACTION_NONE',
  STRIPE_PAYMENT_CLIENT_ACTION_HANDLE_NEXT_ACTION = 'STRIPE_PAYMENT_CLIENT_ACTION_HANDLE_NEXT_ACTION',
  STRIPE_PAYMENT_CLIENT_ACTION_CHANGE_PAYMENT_METHOD = 'STRIPE_PAYMENT_CLIENT_ACTION_CHANGE_PAYMENT_METHOD',
}
export type PaymentProduct = {
  id: string;
  name: string;
  platform: PaymentPlatform;
  trialDays: number;
  price: number;
  termByMonth: number;
};

export type StripePaymentSubscriptionResponse = {
  clientAction: StripePaymentClientAction;
  clientSecret: string;
  paymentMethodId: string;
};

export type PaymentSubscription = {
  id: string;
  userId: string;
  paymentPlatform: payment.PaymentPlatform;
  product?: PaymentProduct;
  startedAt: Date;
  startedAtISOString: string;
  expiresAt: Date;
  expiresAtISOString: string;
  resumeAt: Date;
  resumeAtISOString: string;
  isAutoRenewable: boolean;
  isTrial: boolean;
  isPending: boolean;
  chargeFailedAt: Date;
  chargeFailedAtISOString: string;
  nextChargeAt: Date;
  nextChargeAtISOString: string;
  updatedAt: Date;
  updatedAtISOString: string;
};
